// extracted by mini-css-extract-plugin
export default {"overTestBlock":"Summary_overTestBlock__aj-qT","textRight":"Summary_textRight__h8eav","testBlock":"Summary_testBlock__cUFJ+"};